const account = {
  label: 'MY ACCOUNT',
  href: `${process.env.REACT_APP_SITE_URL}/my-account`,
};
const myBox = {
  label: 'MY BOX',
  href: `${process.env.REACT_APP_SITE_URL}/my-box`,
};
const invoiceHistory = {
  label: 'INVOICE HISTORY',
  href: `${process.env.REACT_APP_SITE_URL}/my-account/invoice-history`,
};

export const activateMembership = {
  label: 'ACTIVATE MEMBERSHIP',
  href: '/activate-membership',
};

export const links = [
  account,
  myBox,
  invoiceHistory,
];

export const notSubscribedLinks = [
  myBox,
  invoiceHistory,
];
